var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodMaleSexualHealth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68 93.5",
    style: {
      enableBackground: "new 0 0 68 93.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#618FCB;}\n\t.st1{fill:#25394F;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:0.663;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.2,
    cy: 32.6,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.8,
    cy: 19.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 44.3,
    cy: 18.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 42,
    cy: 25,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 54.5,
    cy: 30.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 36.1,
    cy: 24.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34,
    cy: 4.2,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18.9,
    cy: 21.2,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.2,
    cy: 26.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 17.1,
    cy: 27.5,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 58,
    cy: 34.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 37.7,
    cy: 20,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 49.2,
    cy: 25.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 37.8,
    cy: 11.3,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 29.6,
    cy: 9.3,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,91.6c17.6,0,31.9-14.1,31.9-31.6c0-17.4-14.3-31.6-31.9-31.6S2.1,42.6,2.1,60C2.1,77.4,16.4,91.6,34,91.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 28.4,
    cy: 65.6,
    r: 15.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "39.3,40.7 52.5,40.7 52.5,53.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 39.3,
    y1: 54.1,
    x2: 52.5,
    y2: 40.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodMaleSexualHealth);
export default __webpack_public_path__ + "static/media/Blood_Male_Sexual_Health.34b9c6d213161796860068b1b56a8c35.svg";
export { ForwardRef as ReactComponent };